<template>
    <section class="page-book">
        <div class="qbk-header">
            <img src="../assets/images/logo-red.svg" alt="">
        </div>
        <div class="qbk-book-box">
            <div class="qbk-wrap">
                <div class="qbk-breadcumb">
                    <router-link to="/home">Home</router-link> > <span>Book</span>
                </div>
                <!-- <div class="qbk-book-steps">
                    <div class="active">1. Select Data</div>
                    <div>2. Select Room</div>
                    <div>3. Payment</div>
                    <div>4. Complete</div>
                </div>
                <div class="qbk-book-form">
                    <div class="row">
                        <div class="col-md-4 col-12">
                            <div class="qbk-bf-room-and-guest">
                                <h3>Your Reservation</h3>
                                <div class="form-group">
                                    <label>Room</label>
                                    <select>
                                        <option value="1">1</option>
                                    </select>
                                </div>
                                <div class="form-group-lab">
                                    <label>Guest</label>
                                    <div class="row">
                                        <div class="col-12 col-md-6">
                                            <div class="form-group">
                                                <label>Adult</label>
                                                <select>1</select>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-6">
                                            <div class="form-group">
                                                <label>Children</label>
                                                <select>1</select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <button type="button">search</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-8 col-12">
                            <div class="qbk-bf-date">
                                <div class="row qbk-bf-calendar">
                                    <div class="col-12 col-md-6">
                                        <datepicker :inline="true"></datepicker>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <datepicker :inline="true"></datepicker>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 pt-3">
                                        <p>Select date by clicking on the calendar above</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <iframe src="https://www.e1-booking.com/booking/booking-page.php?id=1526&promo=" class="qbk-booking-frame"></iframe>
            </div>
        </div>
    </section>
</template>
<script>
// import Datepicker from 'vuejs-datepicker';
export default {
    name : 'Book',
    components: {
        // Datepicker
    }
}
</script>